"use strict";

import _warning from "Subschema/../warning";

const api = {
    warning: _warning
};
try {
    if (window) {
        window.UI__USE_AND_BE_FIRED_HOOK = api;
    }
}catch(e){
    //yes, swallow cause the alternative is worse.
}

module.exports = function warning(...args) {
    return api.warning(...args);
};


/** WEBPACK FOOTER **
 ** ./src/warning.js
 **/